<template>
  <el-card class="create-smart-link" v-loading="loading">
    <div class="wrapper">
      <!-- Creative -->
      <section class="panel mt-6">
        <div class="divider"><h3>Creative</h3></div>
        <el-row :gutter="20" class="mt-5 sticky-bar">
          <el-col :span="5">
            <el-select
              v-model="offer_type"
              placeholder="Offer Type"
              @change="getCreativeList()"
              class="mb-4"
              clearable
            >
              <el-option
                v-for="item in offer_type_list"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-col>
          <el-col :span="5">
            <el-select
              v-model="ad_format"
              placeholder="Ad Type"
              @change="getCreativeList()"
              class="mb-4"
              clearable
            >
              <el-option
                v-for="item in ad_type_list"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-col>
          <el-col :span="5">
            <el-select
              v-model="creative_country"
              multiple
              filterable
              collapse-tags
              class="mb-4"
              placeholder="Country"
              @change="getCreativeList()"
            >
              <el-option
                v-for="item in countrys"
                :key="item.code"
                :label="item.code_name"
                :value="item.code"
              >
                <p style="width: 200px;text-overflow: ellipsis;overflow:hidden">
                  {{ item.code_name }}
                </p>
              </el-option>
            </el-select>
          </el-col>
          <el-col :span="5">
            <el-select
              v-model="creative_category"
              multiple
              collapse-tags
              class="mb-4"
              placeholder="Category"
              @change="getCreativeList()"
            >
              <el-option
                v-for="item in offer_setting.category"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-col>
          <el-col :span="5">
            <el-select
              v-model="size"
              clearable
              class="mb-4"
              value-key="id"
              placeholder="Size"
              @change="getCreativeList()"
            >
              <el-option
                v-for="item in size_list"
                :key="item.id"
                :label="item.width + '*' + item.height"
                :value="item"
              ></el-option>
            </el-select>
          </el-col>
          <el-col :span="5">
            <el-input
              class="mb-4"
              v-model="search_name"
              placeholder="Search Name"
              @keyup.native="getCreativeList()"
            ></el-input>
          </el-col>
        </el-row>
        <menuWaterFall
          ref="menuWaterFall"
          :initData.sync="initData"
          :ad_type_list="ad_type_list"
          :select_creative.sync="select_creative"
          :creative_category="offer_setting.category"
          @offerRecommended="openRecommended"
          @changeCreative="changeCreative"
          @openPreview="openPreview"
        ></menuWaterFall>
      </section>
    </div>

    <div
      class="mt-8 center bottom-panel"
      v-if="!default_sml.includes(this.$route.params.offer_id) && ifSmlCreative"
    >
      <el-button @click="cancel" class="long-button">
        Cancel
      </el-button>
      <el-button type="primary" @click="create" class="long-button">
        Save Changes
      </el-button>
    </div>

    <div
      class="mt-8 center bottom-panel"
      v-if="
        (default_sml.includes(this.$route.params.offer_id) || !ifSmlCreative) && !ifToolCreative
      "
    >
      <el-button @click="cancel" class="long-button">
        Back
      </el-button>
    </div>

    <el-dialog
      :title="preview_type === 'non-push' ? 'Landing Page' : 'Advertising Example'"
      :visible.sync="dialogVisible"
      :width="preview_type === 'non-push' ? '800px' : '460px'"
    >
      Traffic:
      <div class="ml-2 mb-2 tag inline-block">
        <el-tag :type="showType(preview.ad_type)">
          {{ showLabel(preview.ad_type, ad_type_list) }}
        </el-tag>
      </div>
      <div class="flex" v-if="preview_type === 'non-push'">
        <el-image style="width: 100%" :src="preview.img_url" fit="contain"></el-image>
      </div>
      <advertisingExample
        v-else
        :url.sync="preview.push_img_url || preview.img_url"
      ></advertisingExample>
    </el-dialog>

    <recommendDrawer
      :getOfferList_="getOfferList_"
      :drawer.sync="drawer"
      :active="active"
      :select_creative="recommend_creative"
      :offer_ratio="offer_ratio"
      :sml_link="sml_link"
      @drawer="changeDrawer"
    ></recommendDrawer>

    <el-drawer
      title="Creative Detail"
      custom-class="create-smart-link"
      :visible.sync="detail_drawer"
      size="70%"
    >
      <el-row justify="space-between" :gutter="24" class="creative-detail mt-5">
        <el-col :span="8">
          <creativeItem
            :creative.sync="select_creative"
            @openDetail="openDetail(select_creative)"
            @openPreview="openPreview(select_creative)"
            @offerRecommended="innerDrawer = true"
            @changeCreative="changeCreative"
            :ad_type_list="ad_type_list"
            :show_detail="true"
            :creative_category="offer_setting.category"
          ></creativeItem>
        </el-col>
        <el-col :span="16">
          <el-card class="box-card">
            <el-tabs v-model="active_detail">
              <el-tab-pane
                label="Advertising Example"
                name="advertising-example"
                v-if="preview_type === 'push'"
              >
                <div class="flex-center">
                  <advertisingExample
                    :url.sync="select_creative.push_img_url || select_creative.img_url"
                  ></advertisingExample>
                </div>
              </el-tab-pane>
              <el-tab-pane label="Landing Page" name="landing-page">
                <el-image
                  style="width: 100%"
                  class="lp-image"
                  :src="select_creative.img_url"
                  fit="contain"
                ></el-image>
              </el-tab-pane>
            </el-tabs>
          </el-card>
        </el-col>
      </el-row>
      <div class="mt-8 center detail-bottom-panel">
        <el-button @click="detail_drawer = false" class="long-button">
          Back
        </el-button>
        <el-button @click="cancelCreative()" class="long-button ml-4">
          Cancel Selection
        </el-button>
      </div>
      <recommendDrawer
        :getOfferList_="getOfferList_"
        :drawer.sync="innerDrawer"
        :active="active"
        :select_creative="select_creative"
        :offer_ratio="offer_ratio"
        :sml_link="sml_link"
        :append_body="true"
        @drawer="changeinnerDrawer"
      ></recommendDrawer>
    </el-drawer>

    <div class="selected-tool" v-if="select_creative.hasOwnProperty('id')">
      <el-card class="">
        Selected
        <div
          class="creative-img pointer mt-1"
          @mouseenter="show_layer = true"
          @mouseleave="show_layer = false"
          @click="openDetail(select_creative)"
        >
          <div v-show="show_layer" class="layer"></div>
          <i v-show="show_layer" class="icon-y-ym_view"></i>
          <el-image :src="select_creative.img_url" fit="contain"></el-image>
        </div>
      </el-card>
    </div>
  </el-card>
</template>

<script>
import { mapState } from 'vuex'
import recommendDrawer from '@/page/offers/recommendDrawer.vue'
import advertisingExample from '@/page/offers/advertisingExample.vue'
import menuWaterFall from '@/components/menuWaterFall.vue'
import creativeItem from '@/components/creativeItem.vue'

export default {
  data() {
    return {
      active: 'scope',
      drawer: false,
      detail_drawer: false,
      innerDrawer: false,
      dialogVisible: false,
      show_layer: false,
      offer_id: this.$route.params.offer_id,
      loading: false,
      filled_oid: 0,
      preview: {},
      initData: this.getCreativeList_,
      getofferlist_timer: 0,
      save_to_leave: false,
      active_detail: 'landing-page',
      creative_list: [],
      offer_detail: {},
      normal: {
        list: [],
        pageInfo: {
          cur: 1,
          per: 10,
          tot: 0,
        },
      },
      prior: {
        list: [],
        filter_list: [],
        show_list: [],
        pageInfo: {
          cur: 1,
          per: 10,
          tot: 0,
        },
      },
      blocked: {
        list: [],
        filter_list: [],
        show_list: [],
        pageInfo: {
          cur: 1,
          per: 10,
          tot: 0,
        },
      },
      sml_link: {
        name: '',
        sml_type: 1,
        payout_price: 0,
        ad_type: 2,
        restriction_type: 1,
        allow_upstream_sml: false,
        os: 0,
        access_type: 0,
        publish_type: 3,
        ader_sml: 1,
        strict: false,
        payout_ratio: 60,
        margin: 50,
        payout_fixed: false,
        package: 'com.cpisml.youmi',
        preview_url: '',
        icon_url:
          'http://static-abs.ymcdn.net/public/ad/preview/7634136300f3b0d7a4867b57b18fb33c.png',
      },
      sml_link_backup: {},

      search: '',
      search_name: '',
      x_countrys: 0,
      country_list: [],
      x_category: 0,
      category_list: [],
      x_conversion: 0,
      conversion_list: [],
      x_carrier: 0,
      carrier_list: [],

      offer_ratio: {},
      // offer: {
      timer: 0,
      preview_type: 'non-push',

      error_page: '',
      countrys: [],
      select_creative: {
        checked: false,
      },
      recommend_creative: {
        checked: false,
      },
      selected_hover: false,
      creative_country: [],
      creative_category: [],
      prior_ratio: 80,
      size_list: [],
      size: {},

      creativePageInfo: {
        cur: 1,
        per: 12,
        tot: 0,
      },
      hover_index: '',
      ad_format: 0,
      ad_type_list: [
        {
          id: 1,
          name: 'In-App',
        },
        {
          id: 2,
          name: 'Popup',
        },
        {
          id: 3,
          name: 'Push Notifications',
        },
        {
          id: 4,
          name: 'Popunder',
        },
        {
          id: 5,
          name: 'Native',
        },
        {
          id: 0,
          name: 'All',
        },
      ],
      offer_type: '',
      offer_type_list: [
        {
          id: 1,
          name: 'App',
        },
        {
          id: 2,
          name: 'Subscription',
        },
        {
          id: 3,
          name: 'App H5',
        },
        {
          id: 4,
          name: 'Leads',
        },
      ],
    }
  },
  computed: {
    ...mapState(['aid', 'offer_setting', 'channel_list', 'default_sml']),
    ifSmlCreative() {
      return this.$route.name === 'sml-creative'
    },
    ifToolCreative() {
      return this.$route.name === 'tools-creative'
    },
  },
  created() {
    this.loading = true
    this.getCreativeSize()
    this.$store.dispatch('getOfferSetting')
    this.$store.dispatch('getChannelList').then(() => {
      if (this.ifSmlCreative) {
        this.getSmartLink().then(() => {
          let sml_link = this.sml_link
          this.getOfferList_(0, undefined, { x_oids: sml_link.offers.concat(sml_link.x_offers) })
          if (this.sml_link.p_material && this.sml_link.p_material.id) {
            this.$http
              .get(`/api/smartlink/creative/${this.sml_link.p_material.id}`, {})
              .then(data => {
                this.select_creative = data.data
                this.select_creative.src = data.data.img_url
                this.select_creative.checked = true
              })
            this.ad_format = this.sml_link.p_material.p_ad_type
          }
          this.$refs.menuWaterFall.init()
          let [sml, send_tag] = this.generateSml(JSON.parse(JSON.stringify(this.sml_link)))
          this.sml_link_backup = { ...sml, ...send_tag }
        })
      } else if (this.ifToolCreative) {
        this.getCreativeList()
        this.loading = false
      } else {
        this.$http.get(`/api/offers/${this.offer_id}/get/`).then(res => {
          this.offer_detail = res.offer
          let index = this.getIndex(this.offer_setting.category, { id: res.offer.category }, 'id')
          if (index > 0) {
            this.creative_category = [res.offer.category]
          }
          this.creative_country = res.offer.target.countries
          this.getCreativeList()
          this.loading = false
        })
      }

      if (this.countrys.length === 0) {
        this.countrys = []

        this.$http
          .get('/api/common/get-countries-r/', {})
          .then(data => {
            for (var i = 0; i < data.list.length; i++) {
              var temp = data.list[i]
              temp.name_code = temp.name + '(' + temp.code + ')'
              this.countrys.push(temp)
            }
          })
          .catch(err => {
            this.notifyOpen('Error', this.executeError(err), 'error')
          })
      }
    })
  },
  methods: {
    showType(type) {
      let map = {
        1: '',
        2: 'info',
        3: 'warning',
        4: 'danger',
        5: 'success',
      }
      return map[type]
    },
    cancelCreative() {
      for (let i = 0; i < this.$refs.menuWaterFall.data.length; i++) {
        let item = this.$refs.menuWaterFall.data[i]
        if (item.checked) {
          item.checked = false
        }
      }
      this.select_creative = {
        checked: false,
      }
      this.detail_drawer = false
    },
    changeCreative(o, from_detail = false) {
      if (from_detail || !o.checked) {
        this.select_creative = {
          checked: false,
        }
        this.detail_drawer = false
      } else {
        this.select_creative = o
        if (this.select_creative.ad_type === 3) {
          this.preview_type = 'push'
        } else {
          this.preview_type = 'non-push'
        }
      }
    },
    openPreview(o, type) {
      this.preview = o
      type = type || 'non-push'
      this.preview_type = type
      this.dialogVisible = true
    },
    openRecommended(o) {
      this.recommend_creative = o
      this.drawer = true
    },
    openDetail(o) {
      this.active_detail = 'landing-page'
      this.detail_drawer = true
    },
    changeDrawer(o) {
      this.drawer = o
    },
    changeinnerDrawer(o) {
      this.innerDrawer = o
    },
    showLayer(index) {
      this.hover_index = index
    },
    hideLayer() {
      this.hover_index = ''
    },
    getTagSetting() {
      return {
        carriers: this.x_carrier ? [] : this.carrier_list,
        x_carriers: this.x_carrier ? this.carrier_list : [],
        conversion_flow: this.x_conversion ? [] : this.conversion_list,
        x_conversion_flow: this.x_conversion ? this.conversion_list : [],
        categories: this.x_category ? [] : this.category_list,
        x_categories: this.x_category ? this.category_list : [],
        countries: this.x_countrys ? [] : this.country_list,
        x_countries: this.x_countrys ? this.country_list : [],
      }
    },
    setTagResultList(list, tag_key, status, key) {
      if (!list || !list.length) {
        return
      }
      this[key] = status
      this[tag_key] = list
    },
    getAdsList(page_current, table, id_list, search) {
      // let offer = this.offer;
      let form = this[table || 'normal']
      let params = {
        search: search,
        p: page_current || 1,
        contain_api: 1,
        n: 100000,
        approve_status: -1,
        is_accurate: 1,
        oids: id_list ? id_list.oids : undefined,
      }
      this.$http.get('/api/offers/list/', { params: params }).then(res => {
        form.list = res.data
        form.filter_list = res.data

        this.customPagination(1, form)
      })
    },
    getSmartLink() {
      return this.$http.get(`/api/smartlink/${this.offer_id}/`).then(res => {
        this.loading = false
        this.payout_type = res.payout_price > 0 ? 2 : 1
        this.offer_type = res.ad_type ? res.ad_type : ''
        this.sml_link = this.offer_detail = res
        this.sml_link.strict = Boolean(this.sml_link.strict)
        if (this.sml_link.aff_settings[this.aid]) {
          this.sml_link.offers = this.sml_link.aff_settings[this.aid].offers
          this.sml_link.x_offers = this.sml_link.aff_settings[this.aid].x_offers
          this.offer_ratio = this.sml_link.aff_settings[this.aid].offer_ratio
          if (this.sml_link.aff_settings[this.aid].prior_ratio >= 1) {
            this.active = 'weight'
            this.prior_ratio = this.sml_link.aff_settings[this.aid].prior_ratio
          }
        }

        let setTagResultList = this.setTagResultList

        if (this.sml_link.offers && this.sml_link.offers.length) {
          this.getAdsList(1, 'prior', { oids: this.sml_link.offers })
        }
        if (this.sml_link.x_offers && this.sml_link.x_offers.length) {
          this.getAdsList(1, 'blocked', { oids: this.sml_link.x_offers })
        }
        setTagResultList(res.categories, 'category_list', 0, 'x_category')
        setTagResultList(res.x_categories, 'category_list', 1, 'x_category')
        setTagResultList(res.conversion_flow, 'conversion_list', 0, 'x_conversion')
        setTagResultList(res.x_conversion_flow, 'conversion_list', 1, 'x_conversion')
        setTagResultList(res.countries, 'country_list', 0, 'x_countrys')
        return res
      })
    },
    getOfferList_(page_current, table, id_list, search) {
      clearTimeout(this.getofferlist_timer)
      let callback = () => {
        let sml_link = this.sml_link
        let offer = this
        let x_oids = id_list
          ? id_list.x_oids
          : this.getIdArray(offer.blocked.list, 'oid').concat(
              this.getIdArray(offer.prior.list, 'oid')
            ) // 后端用于过滤掉已选中的prior offer和blocked offer
        let params = {
          search: search || this.search,
          p: page_current || 1,
          ad_type: sml_link.ad_type,
          os: sml_link.os,
          n: 10,
          x_oids: x_oids,
          do_filter_none: 1,
          restriction_type: sml_link.restriction_type,
          access_type: sml_link.access_type === 0 ? [1, 2] : sml_link.access_type,
          allow_upstream_sml: Number(sml_link.allow_upstream_sml),
          payout_type: [1, 2, 3],
          ...this.getTagSetting(),
        }

        this.$http
          .post('/api/smartlink/get-offer/', params)
          .then(res => {
            this.loading = false
            this['normal'].list = res.data
            this.tot = res.tot
            if (this['normal'].list.length) {
              this.filled_oid = this['normal'].list[0].oid
            } else if (!search) {
              this.filled_oid = 0
            }
            this.changePageItem(this.normal.pageInfo, res)
          })
          .catch(error => {
            this.loading = false
            this.notifyOpen('Error', this.executeError(error), 'error')
          })
      }
      this.getofferlist_timer = setTimeout(() => {
        callback()
      }, 500)
    },

    customPagination(page_current, table) {
      let filter_list = table.filter_list
      let pageInfo = table.pageInfo
      let per_page = pageInfo.per
      let start_index = (page_current - 1) * per_page

      pageInfo.cur = page_current
      pageInfo.tot = filter_list.length
      filter_list.forEach(item => {
        item.ratio = 0
      })
      table.show_list = [...filter_list.slice(start_index, start_index + per_page)]
    },
    // 获取选中的offer id列表
    getOfferSelect(list) {
      if (!list.length) {
        return
      }
      let result = []
      for (let i = 0, il = list.length; i < il; i++) {
        let item = list[i]
        result.push(item.oid)
      }
      return result
    },
    getCreativeSize() {
      this.$http.get('/api/smartlink/creative/get-size', {}).then(data => {
        let list = data.data
        list.forEach((element, index) => {
          element.id = index
        })
        this.size_list = list
      })
    },
    getCreativeList_(index) {
      // this.loading = true
      let { width, height } = this.size
      let params = {
        offer_type: this.offer_type,
        ad_type: this.ad_format || undefined,
        search: this.search_name || undefined,
        category: this.creative_category,
        country: this.creative_country,
        width: width,
        height: height,
        p: index || 1,
        n: this.creativePageInfo.per,
      }
      return this.$http.get('/api/smartlink/creative/', {
        params: {
          ...params,
        },
      })
    },
    getCreativeList(index) {
      this.$refs.menuWaterFall.data = []
      this.$refs.menuWaterFall.page = 1
      this.initData = this.getCreativeList_
      this.$refs.menuWaterFall.init()
    },

    generateSml(sml_link = this.sml_link) {
      let offer = this
      sml_link.allow_upstream_sml = Number(sml_link.allow_upstream_sml)
      sml_link.payout_fixed = Number(sml_link.payout_fixed)
      sml_link.payout_price = Number(sml_link.payout_price)
      sml_link.strict = Number(sml_link.strict)
      sml_link.uid = this.aid
      if (sml_link.ad_type !== 1) {
        sml_link.package = 'com.cpisml.youmi'
        sml_link.preview_url = ''
        sml_link.icon_url =
          'http://static-abs.ymcdn.net/public/ad/preview/7634136300f3b0d7a4867b57b18fb33c.png'
      }
      let { x_countries, carriers, x_carriers, traffic_allow, x_traffic_allow, ...send_tag } = {
        ...this.getTagSetting(),
      }
      let affsetting = {}
      affsetting[this.aid] = {
        aid: sml_link.uid,
        ad_type: sml_link.ad_type,
        offers: this.getOfferSelect(offer.prior.list),
        x_offers: this.getOfferSelect(offer.blocked.list),
        offer_ratio: this.offer_ratio,
        prior_ratio: this.active === 'scope' ? -1 : this.prior_ratio,
      }
      let p_material = {}
      p_material.p_ad_type = this.ad_format
      p_material.id = this.select_creative.id
      sml_link.aff_settings = JSON.stringify(affsetting)
      sml_link.p_material = JSON.stringify(p_material)
      sml_link.filled_oid = this.filled_oid || 200580 // 若是filled_oid为0，中间层会报错，默认可用200580填充
      return [sml_link, send_tag]
    },
    create() {
      let valid1 = true
      let valid2 = true

      if (this.active === 'weight') {
        let form = 'prior_form2'
        if (this.$refs[form]) {
          this.$refs[form].validate(valid => {
            valid2 = valid
          })
        }
      }

      if (valid1 && valid2) {
        this.loading = true
        let [sml_link, send_tag] = this.generateSml()
        this.$http
          .post('/api/smartlink/create/', {
            ...sml_link,
            ...send_tag,
          })
          .then(res => {
            this.loading = false
            this.save_to_leave = true
            this.$router.push({ path: '/smartlink' })
          })
          .catch(error => {
            this.loading = false
            this.notifyOpen('Error', this.executeError(error), 'error')
          })
      }
    },
    cancel() {
      if (this.ifSmlCreative) {
        this.$router.push({ path: '/smartlink' })
      } else {
        this.$router.push({ path: '/sweepstake' })
      }
    },
  },
  components: {
    recommendDrawer,
    creativeItem,
    menuWaterFall,
    advertisingExample,
  },
}
</script>

<style lang="scss">
.flex-center {
  display: flex;
  justify-content: center;
}
.line-popper {
  padding: 5px 8px;
}
.transparent-popper {
  background: rgba(33, 35, 41, 0.7);
  color: #fff;
  border: transparent;
}
.creative-img {
  overflow: hidden;
  position: relative;
  border-radius: 4px;
  .layer {
    position: absolute;
    width: 100%;
    height: 100%;
    background: #37383a;
    opacity: 0.6;
    z-index: 999;
  }
  .icon-y-ym_view {
    color: #fff;
    z-index: 1100;
    position: absolute;
    top: 45%;
    left: 45%;
  }
}
.selected-tool {
  position: fixed;
  right: 16px;
  top: 30%;
  width: 80px;
  height: 106px;
  text-align: center;
  z-index: 1000;
  .el-card__body {
    padding: 8px 12px !important;
    box-sizing: border-box;
    font-size: 14px;
  }
  .el-image {
    width: 56px;
    height: 56px;
  }
  .icon-y-ym_view {
    top: 40%;
    left: 40%;
  }
}
.creative-detail {
  padding: 0 24px !important;
  .lp-image {
    height: 610px;
  }
  .el-card__body {
    padding: 0;
    .el-tabs__nav-scroll {
      padding: 9px 23px 0 23px;
      background: #fafcff;
    }
  }
}
.detail-bottom-panel {
  position: fixed;
  bottom: 0;
  width: 70%;
  z-index: 999;
  background: #fff;
  padding: 12px;
  border-top: 1px solid #eef0f6;
}
.sticky-bar {
  position: sticky;
  top: -34px;
  background: #fff;
  z-index: 999;
}
.create-smart-link {
  .ad-type-group {
    display: inline-block !important;
    max-width: 800px;
  }
  .el-drawer__header {
    margin-bottom: 0;
    & > :first-child {
      font-size: 20px;
      font-weight: 400;
      color: rgba(0, 128, 204, 1);
      line-height: 28px;
    }
  }
  .el-drawer__body {
    padding: 0 25px;
    overflow-y: auto;
    h3 {
      display: inline-block;
      line-height: 24px;
    }
    p {
      font-size: 12px;
      line-height: 28px;
    }
    .prior-list {
      padding-bottom: 60px;
    }
    .recommend-list .el-table__body-wrapper {
      height: 240px;
      overflow-y: scroll;
    }
  }

  .drawer_bottom {
    position: absolute;
    bottom: 0;
    width: 100%;
    left: 0;
    padding: 12px;
    border-top: 1px solid #eef0f6;
    background: #fff;
    z-index: 999;
  }
  &.el-card {
    overflow: visible;
  }
  .el-card__body {
    overflow: visible;
    width: 100%;
    padding: 0;
  }
  .el-input-number {
    width: 540px;
    input {
      text-align: left;
    }
  }
  .prior-option {
    display: flex;
    align-items: center;
    width: 166px;
    height: 40px;
    box-shadow: none !important;
    .el-card__body {
      text-align: center;
    }
    .el-radio {
      margin-right: 10px;
    }
  }

  .wrapper {
    padding: 0 28px 0 28px;
    min-height: 700px;
  }
  p {
    color: #6b6d71;
    font-size: 14px;
  }
  .flex-center {
    display: flex;
    flex-direction: column;
    align-items: center;
    flex-wrap: wrap;
  }
  .panel {
    margin: 20px auto;
    padding-bottom: 40px;
  }
  .el-tag {
    line-height: 24px;
    height: 24px;
  }
  .form-group {
    height: 32px;
    margin-bottom: 10px;
  }

  .target-group {
    margin-top: 15px;
    flex-wrap: nowrap;
    height: auto;
  }
  .tag-group {
    border: 1px solid #dcdfe6;
    border-radius: 4px;
    padding: 12px;
    margin-left: 75px;
    overflow-y: auto;
    width: 590px;
    height: 100%;
  }
  .tag-wrapper {
    margin-top: 15px;
    margin-bottom: 40px;
    height: 120px;
  }
  .radio-group {
    align-items: center;
    display: inline-flex;
    .el-form-item {
      margin-bottom: 0;
    }
  }

  .el-select {
    height: 32px;
  }
  .label {
    width: 120px;
  }
  .label.mr-8 {
    margin-right: 40px;
  }
  .s-label {
    color: #9b9ea3;
    font-size: 14px;
  }
  .form-control {
    width: 476px;
    .el-form-item {
      width: 100%;
    }
  }
  .divider {
    position: relative;
    h3 {
      color: #6b6d71;
      font-size: 16px;
      line-height: 36px;
    }
    &::after {
      content: '';
      position: absolute;
      left: 0;
      bottom: 0;
      width: 100%;
      height: 1px;
      background-color: #e4e7ed;
      z-index: 1;
    }
  }

  .allow {
    .el-input__inner {
      border: 1px solid #0080cc;
      color: #0080cc;
    }
    .el-input {
      &.is-focus .el-input__inner {
        border-color: #0080cc;
      }
      .el-select__caret {
        color: #0080cc;
      }
    }
  }
  .deny {
    .el-input__inner {
      border: 1px solid #f56c6c;
      color: #f56c6c;
    }
    .el-input {
      &.is-focus .el-input__inner {
        border-color: #f56c6c;
      }
      .el-select__caret {
        color: #f56c6c;
      }
    }
  }
  .target-tag {
    background: #eaf2f6;
    border-color: #eaf2f6;
  }
  .el-tag--danger {
    background: #f6eaea;
    border-color: #f6eaea;
  }
  .ratio {
    margin-bottom: 0;
    padding: 16px 0;
  }

  .error_tip {
    color: #f56c6c;
    font-size: 12px;
    line-height: 1;
  }

  .creative-box {
    padding: 32px 22px;
    height: 546px;
    overflow-y: scroll;
    background: #f6f8fb;
    border-radius: 4px;
    border: 1px solid #ebeef5;
    .box {
      margin: 0 -12px;
    }
    .creative-card-box {
      margin: 0 12px 32px 12px;
      display: inline-block;
    }
  }

  .creative-card-box {
    max-width: 224px !important;
    width: 224px;
    height: 204px;
    .el-card {
      box-shadow: none !important;
      &:hover {
        box-shadow: 0px 10px 20px 0px rgba(36, 117, 164, 0.16) !important;
      }
    }
    .el-card__body {
      padding: 0;
    }
    .icon-y-ym_view {
      font-size: 24px;
    }
  }

  .creative-info {
    padding: 12px 16px 12px 16px;
  }

  .creative-select-panel {
    .creative-card-box {
      max-width: 300px !important;
      width: auto;
      height: auto;
    }
  }
  .ad-format-box {
    margin-bottom: 24px;
    display: inline-block;
    align-items: center;
    padding: 20px;
    box-sizing: border-box;
    text-align: center;
    width: 226px;
    height: 138px;
    .el-radio {
      margin-right: 0;
    }
  }
  .el-steps {
    width: 60%;
    margin: 0 auto;
    position: relative;
    left: -4%;
  }
  .is-process {
    .el-step__icon {
      border: none;
    }
    .el-step__icon-inner {
      color: #fff;
    }
  }
  .el-step__icon {
    cursor: pointer;
  }
  .el-step.is-horizontal .el-step__line {
    left: 120px;
    right: 10px;
  }
  .el-step__main {
    position: absolute;
    top: -8px;
    left: 36px;
  }
  .el-step__title {
    width: 150px;
  }
  .el-step__icon.is-text {
    border: 1px solid #eef0f6;
  }
  .el-step__icon-inner {
    color: #6b6d71;
  }
  .el-step__head.is-wait {
    border-color: #eef0f6;
  }
  .el-step__title.is-wait {
    color: #6b6d71;
  }
  .el-step__title.is-success,
  .el-step__title.is-process {
    color: #0080cc;
  }
  .el-step.is-horizontal:nth-child(2) .el-step__line {
    left: 95px;
  }

  .ad-format {
    width: 105px;
  }
  .el-input--suffix .el-input__inner {
    height: 32px !important;
  }

  .el-icon-more {
    &:hover {
      color: #0080cc;
    }
  }
  .icon {
    width: 56px;
    height: 56px;
    cursor: pointer;
  }
}

.ym-container.el-container .ym-main .create-smart-link .el-card.is-always-shadow {
  box-shadow: 0px 10px 20px 0px rgba(36, 117, 164, 0.16);
}

.tag {
  .el-tag {
    padding: 0 4px;
    line-height: 12px;
    height: 16px;
    border-radius: 4px 4px 4px 0px;
    font-size: 12px;
    color: #fff;
    background: #a980ff;
    border-color: transparent;
    &.el-tag--info {
      background: #2cb5ff;
      border-color: transparent;
    }
    &.el-tag--warning {
      background: #fa9005;
      border-color: transparent;
    }
    &.el-tag--danger {
      background: #fb5b94;
      border-color: transparent;
    }
    &.el-tag--success {
      background: #84d245;
      border-color: transparent;
    }
  }
}
i.icon-y-ym_star_full {
  color: #84d245;
}
i.icon-y-ym_star {
  color: #c7cbd2;
}
</style>
